import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'

import AddEditForm from './AddEditForm/AddEditForm'
import { EDIT_GROUP } from './Edit.queries'

const Edit = () => {
    const { t } = useTranslation()
    const { guid } = useParams()

    const { loading, data } = useQuery<any>(EDIT_GROUP, {
        variables: {
            guid,
        },
        fetchPolicy: 'cache-and-network', // Always show latest group pages
    })

    if (loading) {
        return null
    }

    const { entity, groupPages, viewer, site } = data || {}

    if (!entity || !entity?.canEdit) {
        return <NotFound />
    }

    return (
        <AddEditForm
            title={t('entity-group.edit')}
            entity={entity}
            viewer={viewer}
            site={site}
            groupPages={groupPages}
        />
    )
}

export default Edit
